module.exports = __webpack_public_path__ + "static/media/jacob.51e8cbc5.webp";